module.exports = __webpack_public_path__ + "static/img/project_item_1a.1db45eb.png";


//////////////////
// WEBPACK FOOTER
// ./static/funding_cpunk/project_item_1a.png
// module id = ZZtt
// module chunks = 1